import * as React from 'react';

import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { ReactComponent as WarningExclamation } from 'assets/big-warning-exclamation.svg';
import styled from '@emotion/styled';
import { colors } from 'styles/colors';
import { SoloButton } from './SoloButton';
import './ConfirmationModal.css';

const maskStyle = {
  background: 'rgba(255, 255, 255, 0)'
};
const floatingStyle = {
  borderRadius: '10px'
};
const bodyStyle = {
  borderRadius: '10px'
};

interface Props extends ModalProps {
  confirmationTopic?: string;
  confirmText?: string;
  goForIt: () => any;
  cancel: () => any;
  visible?: boolean;
  isNegative?: boolean;
}

export const ConfirmationModal = (props: Props) => {
  const closeModal = (): void => {
    props.cancel();
  };

  const { confirmationTopic, confirmText, goForIt, isNegative } = props;

  return (
    <>
      <Modal
        visible={props.visible}
        footer={null}
        onCancel={closeModal}
        width={360}
        maskStyle={maskStyle}
        style={floatingStyle}
        bodyStyle={bodyStyle}>
        <div className='content-container'>
          <div className='warning-circle'>
            <WarningExclamation title='' />
          </div>
          <div className='content-text'>
            Are you sure you want to {!!confirmationTopic ? confirmationTopic : 'remove this'}?
          </div>

          <div className='button-group'>
            <SoloButton onClick={goForIt} text={!!confirmText ? confirmText : 'Confirm'} isNegative={isNegative} />
          </div>
        </div>
      </Modal>
    </>
  );
};
